// extracted by mini-css-extract-plugin
export default {"footer":"style-module__footer___v8OP7","footer__preview_button":"style-module__footer__preview_button___OPchC","footer__save_button":"style-module__footer__save_button___VwIx_"};
    if(module.hot) {
      // 1729151120413
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  